import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appMatchName]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MatchNameDirective, multi: true }],
  standalone: false
})
export class MatchNameDirective implements Validator {
  @Input('appMatchName') name: string;

  static validator(control: AbstractControl, name: string): ValidationErrors | null {
    return MatchNameDirective.matches(control.value, name) ? null : { appMatchName: true };
  }

  static matches(controlValue: string, validationName?: string): boolean {
    if (!validationName) return true;

    const normalized = (val: string) => val?.trim()?.toLowerCase();

    return typeof controlValue === 'string' && typeof validationName === 'string' && normalized(validationName) === normalized(controlValue);
  }

  validate(control: AbstractControl) {
    return MatchNameDirective.validator(control, this.name);
  }
}
